import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const designSystemPlugin = createPlugin({
  id: 'design-system',
  routes: {
    root: rootRouteRef,
  },
});

export const DesignSystemPage = designSystemPlugin.provide(
  createRoutableExtension({
    name: 'DesignSystemPage',
    component: () =>
      import('./pages/DesignSystemPage').then(m => m.DesignSystemPage),
    mountPoint: rootRouteRef,
  }),
);
